import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
    ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Social Event', value: 'Social Event' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Planned Guest Count:',
            options: [
              { label: '50-100', value: '50-100' },
              { label: '100-150', value: '100-150' },
              { label: '150-200', value: '150-200' },
              { label: '200-250', value: '200-250' },
              { label: '250+', value: '250+' },
            ],
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you hear about The Piermont?:',
            options: [
              { label: 'Google Search', value: 'Google Search' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Referral', value: 'Referral' },
              { label: 'The Knot', value: 'The Knot' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'Zola', value: 'Zola' },
              { label: 'Brides of Long Island', value: 'Brides of Long Island' },
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Information:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Piermont Events Form',
    formId: '2073',
    clientKey: '53AD3228-5F10-4B57-B425-DD60D37A1489',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. Our catering coordinator will reach out to you within 24 business hours.',
    redirectUrl: 'https://www.thepiermontny.com/thank-you/',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
